import { Helmet } from "react-helmet-async";
import VenueHeader from "../VenueHeader";
import FooterLogin from "src/layouts/compact/FooterLogin";
import ReservationHistory from "./ReservationHistory";
import { Box } from "@mui/material";

const ReservationHistoryPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Helmet>
        <title>Egora-Reservation</title>
      </Helmet>
      <VenueHeader />
      <ReservationHistory />
      <FooterLogin />
    </Box>
  );
};
export default ReservationHistoryPage;